export default __webpack_public_path__ + "static/media/fireFN3.8503aa16.svg";